module.exports = __webpack_public_path__ + "static/img/heart-outlined.aa30c46d.svg";